'use client';

import { Card, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import { useEffect, useRef } from 'react';
import { usePaybackClient } from './usePaybackClient';
import { paybackMessages } from './messages';

const paybackECouponDiv = 'couponnutshell';

export const PaybackCouponCard = () => {
  const { formatMessage } = useIntl();
  const divRef = useRef<HTMLDivElement>(null);
  const context = usePaybackClient();

  if (!context) {
    throw new Error('usePaybackClient must be used within PaybackClientProvider');
  }

  useEffect(() => {
    const createModule = async () =>
      context?.client?.createModule({
        moduleType: 'coupon',
        selector: `#${paybackECouponDiv}`,
        width: divRef.current?.clientWidth ?? 300,
        height: 300,
        contextKey: 'partnerWithoutPaybackContext',
      });
    createModule();
  }, [context?.client]);

  return (
    <Card>
      <CardHeader hasDivider>
        <div className="text-size-headline-base">
          {formatMessage(paybackMessages.externalCardHeadline)}
        </div>
      </CardHeader>
      <div className="p-2">
        <div ref={divRef} title="payback-ecoupons" id={paybackECouponDiv} />
      </div>
    </Card>
  );
};
